export default __webpack_public_path__ + "static/media/header.2878f24d.jpg";